import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { ReportsEntityGrid } from '../features/reports-entity-grid';

export const AllReportsPage = observer(() => {
  return (
    <AppPage perm="PERM_REPORT_TEMPLATE_READ" noWrapper>
      <ReportsEntityGrid />
    </AppPage>
  );
});
